type DeviceType = 'tablet' | 'mobile' | 'desktop' | 'unknown';

export const getCurrentDeviceType = (): DeviceType => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'unknown'; // For SSR or non-browser environments
  }
  const ua = (navigator.userAgent || '').toLowerCase();
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const screenWidth = window.screen?.width || 0;
  // --- Tablet detection ---
  if (
    ua.includes('ipad') ||
    (ua.includes('android') && !ua.includes('mobile') && !ua.includes('sm-')) || // Android tablets
    (ua.includes('macintosh') && isTouch) || // iPadOS masquerading as Mac
    ua.includes('tablet') ||
    (ua.includes('windows') && ua.includes('touch')) || // Windows tablets
    (ua.includes('android') && screenWidth >= 768)
  ) {
    return 'tablet';
  }
  // --- Mobile detection ---
  if (
    /iphone|ipod|android.*mobile|webos|blackberry|windows phone|iemobile|opera mini|mobile safari/.test(ua) ||
    (isTouch && screenWidth > 0 && screenWidth < 768)
  ) {
    return 'mobile';
  }
  // --- Desktop detection ---
  if (
    ua.includes('windows') ||
    (ua.includes('macintosh') && !isTouch) ||
    ua.includes('linux') ||
    ua.includes('x11') ||
    ua.includes('cros') // Chrome OS
  ) {
    return 'desktop';
  }
  // --- Fallbacks based on screen width ---
  if (screenWidth >= 1024) {
    return 'desktop';
  }
  if (screenWidth >= 768 && isTouch) {
    return 'tablet';
  }
  if (screenWidth > 0 && isTouch) {
    return 'mobile';
  }

  return 'unknown';
};
